export function getPronounceUrl(url) {
  return `http://inter.youdao.com/dictvoice?audio=${url}&type=1&le=en&keyfrom=`
}

export function isMobile() {
  return window.navigator.userAgent.toLowerCase().indexOf('mobile') > -1
}
export function dateFormatter(date) {
  const year = date.getFullYear()
  const month = date.getMonth() + 1 > 9
    ? date.getMonth() + 1
    : `0${date.getMonth() + 1}`
  const day = date.getDate() > 9 ? date.getDate() : `0${date.getDate()}`
  return `${year}-${month}-${day}`
}

export function getResultUrl(word, from, to) {
  const path = isMobile() ? '' : '/home'
  return `${path}/word/${word}/from/${from}/to/${to}`
}

export function setAudioPause() {
  const audios = document.getElementsByTagName('audio')
  for (let i = 0; i < audios.length; i += 1) {
    audios[i].pause()
  }
}
